"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Common_1 = require("./Common");
const clsx_1 = __importDefault(require("clsx"));
const utils_1 = require("../../utils"); // Did it this way
const TGTextHeader = props => {
    const { translateFunction = text => text } = props;
    const headerStyles = useHeaderStyles();
    const styles = (0, Common_1.useStyles)();
    const renderText = txt => txt.split(' ').map(part => utils_1.URL_REGEX.test(part) ? (react_1.default.createElement("a", { href: part.startsWith(utils_1.WWW_URL_PREFIX) ? `${utils_1.HTTPS_URL_PREFIX}${part}` : part, target: "_blank" }, part)) : (part + ' '));
    return (react_1.default.createElement(core_1.Typography, Object.assign({}, props, { className: (0, clsx_1.default)([styles.formElementWrapper, headerStyles.header]) }), renderText(translateFunction(props.label))));
};
const useHeaderStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    header: {
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '20px',
    },
}));
exports.default = TGTextHeader;
//# sourceMappingURL=TGTextHeader.js.map